import {ApiOutlined, BarChartOutlined, SolutionOutlined, TeamOutlined, UploadOutlined} from "@ant-design/icons";
import {Menu} from "antd";
import {NavLink} from "react-router-dom";
import {RoutingPaths} from "../../routing/routingContainer";
import styles from "./siderMenu.module.less"
import {useCurrentRoutingPath} from "digimuth-components/dist";
import {useDispatch, useSelector} from "react-redux";
import {getCurrentUser, setCurrentUser} from "../../../redux/applicationUserSlice";
import {ApplicationUserApi, ApplicationUserRole} from "../../../api";
import {useCallback, useEffect, useState} from "react";
import {useAuth} from "oidc-react";
import {useInjection} from "inversify-react";
import ApiService from "../../../services/apiService";

export default function SiderMenu() {
    const route = useCurrentRoutingPath(RoutingPaths)?.route || "";
    const apiService = useInjection(ApiService);
    const dispatch = useDispatch();
    const auth = useAuth();
    const user = useSelector(getCurrentUser);
    const isTestEnvironment = ["localhost", "127.0.0.1", "::1"]
        .includes(window.location.hostname.toLowerCase());

    const updateCurrentUserInStore = useCallback(async () => {
        const response = await apiService.getApi(ApplicationUserApi)
            .apiApplicationUserIdGet(Number(auth.userData?.profile.sub));
        dispatch(setCurrentUser(response.data));
    }, [auth.userData, apiService, dispatch]);

    useEffect(() => {
        updateCurrentUserInStore();
    }, [updateCurrentUserInStore]);

    const menuItems = [
        ...user?.roles?.includes(ApplicationUserRole.Admin) ? [{
            key: RoutingPaths.users.route,
            icon: <TeamOutlined/>,
            label: <NavLink to={RoutingPaths.users.route}>
                Lista użytkowników
            </NavLink>
        }] : [],
        {
            key: RoutingPaths.reportingUsers.route,
            icon: <SolutionOutlined/>,
            label: <NavLink to={RoutingPaths.reportingUsers.route}>
                Urządzenia
            </NavLink>
        },
        ...(!user?.roles?.includes(ApplicationUserRole.LmItSupport) || user?.canReadTransactions) ? [{
            key: RoutingPaths.transactions.route,
            icon: <BarChartOutlined/>,
            label: <NavLink to={RoutingPaths.transactions.route}>
                Wszystkie transakcje
            </NavLink>
        }] : [],
        ...user?.roles?.includes(ApplicationUserRole.Admin) || user?.roles?.includes(ApplicationUserRole.DeviceAdmin) ? [{
            key: RoutingPaths.deviceManualUpdate.route,
            icon: <UploadOutlined/>,
            label: <NavLink to={RoutingPaths.deviceManualUpdate.route}>
                Wgrywanie transakcji
            </NavLink>
        }] : [],
        ...user?.roles?.includes(ApplicationUserRole.Admin)
        || user?.roles?.includes(ApplicationUserRole.LmItSupport) ? [{
            key: RoutingPaths.lmCommunicationHistory.route,
            icon: <ApiOutlined/>,
            label: <NavLink to={RoutingPaths.lmCommunicationHistory.route}>
                Raporty LM
            </NavLink>
        }] : []
    ]

    return <>
        <NavLink to={"/"}>
            <img className={styles.logo} src="/talemax-logo.png" alt="Logo Talemax"/>
        </NavLink>
        {isTestEnvironment && <div className={styles.environmentLabel}>
            Środowisko testowe
        </div>}

        <Menu
            theme="dark"
            selectedKeys={[route]}
            mode="inline"
            items={menuItems}
        />
    </>
}
